"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PageFiveForcedContent;
var _react = _interopRequireDefault(require("react"));
var _NeedsAttention = _interopRequireDefault(require("../svg/NeedsAttention"));
var _AllGood = _interopRequireDefault(require("../svg/AllGood"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var allGoodDesc = /*#__PURE__*/_react.default.createElement("p", null, "Connect with a financial professional today and see how your extra cash can work for you.");
var needsAttentionDesc = /*#__PURE__*/_react.default.createElement("p", null, "A financial professional can develop a personalized plan for your retirement.");
function PageFiveForcedContent(_ref) {
  var {
    hasRetirementIncomeGap
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, hasRetirementIncomeGap ? /*#__PURE__*/_react.default.createElement(_NeedsAttention.default, {
    className: "mm-spacing--minor"
  }) : /*#__PURE__*/_react.default.createElement(_AllGood.default, {
    className: "mm-spacing--minor"
  }), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
    className: "eyebrow"
  }, "YOUR RETIREMENT GAP"), /*#__PURE__*/_react.default.createElement("h2", {
    className: "margin-top-0"
  }, ' ', hasRetirementIncomeGap ? 'Needs Attention' : 'All Good')), /*#__PURE__*/_react.default.createElement("h3", null, "Next Step"), hasRetirementIncomeGap ? needsAttentionDesc : allGoodDesc);
}